// import { useState } from "react";
// import Button from "../Dealers/Button";

// // ─── Queue Edit Mini Modal ────────────────────────────────────────────────────
// const QueueEditModal = ({
//   item,
//   maxQueue,
//   onConfirm,
//   onClose,
//   mode,
//   activeType,
// }) => {
//   const [val, setVal] = useState(item?.queueNo || 1);
//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         backgroundColor: "rgba(0,0,0,0.5)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 10000,
//       }}
//       onClick={onClose}
//     >
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           backgroundColor: mode ? "#2C2E33" : "#fff",
//           color: mode ? "#fff" : "#000",
//           borderRadius: 16,
//           padding: 24,
//           maxWidth: 450,
//           boxShadow: "0 8px 40px rgba(0,0,0,0.2)",
//         }}
//       >
//         <p style={{ margin: "0 0 8px", fontSize: 16, fontWeight: 500 }}>
//           Update <span style={{ color: "#4164E3" }}>{activeType}</span> Queue
//           Position
//         </p>

//         <div
//           style={{ flex: 1, display: "flex", flexDirection: "column", gap: 5 }}
//         >
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               alignItems: "center",
//               justifyContent: "space-between",
//             }}
//           >
//             <p>Voucher Id : </p>
//             <p>{item.voucherNo}</p>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               alignItems: "center",
//               justifyContent: "space-between",
//             }}
//           >
//             <p>Customer : </p>
//             <p>{item.customer}</p>
//           </div>
//         </div>

//         <p
//           style={{
//             margin: "0 0 16px",
//             fontSize: 13,
//             color: mode ? "#aaa" : "#6B7280",
//           }}
//         >
//           Enter a position (1–{maxQueue}) for{" "}
//           <strong>{item?.voucherNo || item?.orderId || item?.machine}</strong>
//         </p>

//         <input
//           type="number"
//           min={1}
//           max={maxQueue}
//           value={val}
//           onChange={(e) => setVal(e.target.value)}
//           style={{
//             width: "100%",
//             height: 44,
//             border: "1.5px solid #4164E3",
//             borderRadius: 8,
//             padding: "0 12px",
//             fontSize: 14,
//             backgroundColor: mode ? "#1b1d21" : "#fff",
//             color: mode ? "#fff" : "#000",
//             outline: "none",
//             boxSizing: "border-box",
//           }}
//         />
//         <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
//           <Button
//             buttonClick={onClose}
//             buttonText={"Cancel"}
//             buttonBgColor={"#000000"}
//             buttonTextColor={"#ffffff"}
//           />

//           <Button
//             buttonClick={() => {
//               onConfirm(parseInt(val, 10));
//               onClose();
//             }}
//             buttonText={"Confirm"}
//             buttonBgColor={"#4164E3"}
//             buttonTextColor={"#ffffff"}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default QueueEditModal;

// import { useState } from "react";
// import Button from "../Dealers/Button";

// // ─── Queue Edit Mini Modal ────────────────────────────────────────────────────
// const QueueEditModal = ({
//   item,
//   maxQueue,
//   onConfirm,
//   onClose,
//   mode,
//   activeType,
// }) => {
//   const [val, setVal] = useState(item?.queueNo ?? 1);

//   const primaryLabel = item?.voucherNo
//     ? "Voucher No"
//     : item?.machine && activeType === "Machine Wise"
//       ? "Machine"
//       : "Order Id";

//   const primaryValue = item?.voucherNo || item?.orderId || item?.machine || "-";

//   const handleConfirm = () => {
//     const newPosition = Math.max(1, Math.min(maxQueue, Number(val) || 1));

//     onConfirm(newPosition);
//     onClose();
//   };

//   return (
//     <div
//       onClick={onClose}
//       style={{
//         position: "fixed",
//         inset: 0,
//         backgroundColor: "rgba(0,0,0,0.55)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 10000,
//         padding: 20,
//       }}
//     >
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           width: "100%",
//           maxWidth: 450,
//           backgroundColor: mode ? "#232529" : "#FFFFFF",
//           color: mode ? "#FFFFFF" : "#111827",
//           borderRadius: 16,
//           padding: 24,
//           boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
//         }}
//       >
//         {/* Header */}
//         <div style={{ marginBottom: 18 }}>
//           <h3
//             style={{
//               margin: 0,
//               fontSize: 18,
//               fontWeight: 600,
//               textAlign: "center",
//             }}
//           >
//             Update <span style={{ color: "#4164E3" }}>{activeType}</span> Queue
//           </h3>

//           <p
//             style={{
//               marginTop: 6,
//               marginBottom: 0,
//               fontSize: 13,
//               color: mode ? "#ffffff" : "#000000",
//               textAlign: "center",
//             }}
//           >
//             Change the queue position for this production.
//           </p>
//         </div>

//         {/* Info Card */}
//         <div
//           style={{
//             background: mode ? "#1B1D21" : "#F8FAFC",
//             border: `1px solid ${mode ? "#3A3D44" : "#E5E7EB"}`,
//             borderRadius: 12,
//             padding: 14,
//             marginBottom: 18,
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               gap: 12,
//             }}
//           >
//             <span
//               style={{
//                 fontSize: 13,
//                 color: mode ? "#FFFFFF" : "#000000",
//               }}
//             >
//               {primaryLabel}
//             </span>

//             <span
//               style={{
//                 fontSize: 13,
//                 fontWeight: 600,
//                 textAlign: "right",
//               }}
//             >
//               {primaryValue}
//             </span>
//           </div>

//           {item?.customer && (
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 gap: 12,
//               }}
//             >
//               <span
//                 style={{
//                   fontSize: 13,
//                   color: mode ? "#FFFFFF" : "#000000",
//                 }}
//               >
//                 Customer
//               </span>

//               <span
//                 style={{
//                   fontSize: 13,
//                   textAlign: "right",
//                   maxWidth: 220,
//                 }}
//               >
//                 {item.customer}
//               </span>
//             </div>
//           )}

//           {item?.itemCode && (
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 gap: 12,
//               }}
//             >
//               <span
//                 style={{
//                   fontSize: 13,
//                   color: mode ? "#FFFFFF" : "#000000",
//                 }}
//               >
//                 Item Code
//               </span>

//               <span
//                 style={{
//                   fontSize: 13,
//                   fontWeight: 500,
//                 }}
//               >
//                 {item.itemCode}
//               </span>
//             </div>
//           )}

//           {item?.collection && item.collection !== "—" && (
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 gap: 12,
//               }}
//             >
//               <span
//                 style={{
//                   fontSize: 13,
//                   color: mode ? "#FFFFFF" : "#000000",
//                 }}
//               >
//                 Collection
//               </span>

//               <span style={{ fontSize: 13 }}>{item.collection}</span>
//             </div>
//           )}

//           {item?.machine && activeType !== "Machine Wise" && (
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 gap: 12,
//               }}
//             >
//               <span
//                 style={{
//                   fontSize: 13,
//                   color: mode ? "#FFFFFF" : "#000000",
//                 }}
//               >
//                 Machine
//               </span>

//               <span style={{ fontSize: 13 }}>{item.machine}</span>
//             </div>
//           )}
//         </div>

//         {/* Queue Position */}
//         {/* <div style={{ marginBottom: 18 }}>
//           <label
//             style={{
//               display: "block",
//               marginBottom: 8,
//               fontSize: 13,
//               fontWeight: 500,
//             }}
//           >
//             Queue Position
//           </label>

//           <p
//             style={{
//               marginTop: 0,
//               marginBottom: 12,
//               fontSize: 12,
//               lineHeight: 1.5,
//               color: mode ? "#A1A1AA" : "#6B7280",
//             }}
//           >
//             Move <strong>{primaryValue}</strong> to a position between{" "}
//             <strong>1</strong> and <strong>{maxQueue}</strong>.
//           </p>

//           <input
//             type="number"
//             min={1}
//             max={maxQueue}
//             value={val}
//             onChange={(e) => setVal(e.target.value)}
//             style={{
//               width: "100%",
//               height: 46,
//               borderRadius: 10,
//               border: "1.5px solid #4164E3",
//               padding: "0 14px",
//               fontSize: 14,
//               backgroundColor: mode ? "#1B1D21" : "#FFFFFF",
//               color: mode ? "#FFFFFF" : "#111827",
//               outline: "none",
//               boxSizing: "border-box",
//             }}
//           />
//         </div> */}

//         {/* Queue Position */}
//         <div style={{ marginBottom: 18 }}>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               gap: 20,
//               alignItems: "flex-start",
//             }}
//           >
//             {/* Current Queue */}
//             <div style={{ flex: 1 }}>
//               <label
//                 style={{
//                   display: "block",
//                   marginBottom: 8,
//                   fontSize: 13,
//                   fontWeight: 600,
//                 }}
//               >
//                 Current Queue
//               </label>

//               <div
//                 style={{
//                   height: 56,
//                   display: "flex",
//                   alignItems: "center",
//                   fontSize: 28,
//                   fontWeight: 700,
//                   color: "#4164E3",
//                 }}
//               >
//                 {item?.queueNo || 1}
//               </div>
//             </div>

//             {/* New Queue */}
//             <div style={{ flex: 1 }}>
//               <label
//                 style={{
//                   display: "block",
//                   marginBottom: 8,
//                   fontSize: 13,
//                   fontWeight: 600,
//                 }}
//               >
//                 New Queue
//               </label>

//               <input
//                 type="number"
//                 min={1}
//                 max={maxQueue}
//                 value={val}
//                 onChange={(e) => setVal(e.target.value)}
//                 style={{
//                   width: "100%",
//                   height: 56,
//                   borderRadius: 10,
//                   border: "1.5px solid #4164E3",
//                   textAlign: "center",
//                   fontSize: 28,
//                   fontWeight: 700,
//                   backgroundColor: mode ? "#1B1D21" : "#FFFFFF",
//                   color: mode ? "#FFFFFF" : "#111827",
//                   outline: "none",
//                   boxSizing: "border-box",
//                 }}
//               />
//             </div>
//           </div>

//           <p
//             style={{
//               marginTop: 12,
//               marginBottom: 0,
//               fontSize: 12,
//               lineHeight: 1.5,
//               color: mode ? "#A1A1AA" : "#6B7280",
//               textAlign: "center",
//             }}
//           >
//             Move <strong>{primaryValue}</strong> to a position between{" "}
//             <strong>1</strong> and <strong>{maxQueue}</strong>.
//           </p>
//         </div>

//         {/* Actions */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "flex-end",
//             gap: 10,
//           }}
//         >
//           <Button
//             buttonClick={onClose}
//             buttonText="Cancel"
//             buttonBgColor={"#000000"}
//             buttonTextColor="#FFFFFF"
//           />

//           <Button
//             buttonClick={handleConfirm}
//             buttonText="Confirm"
//             buttonBgColor="#4164E3"
//             buttonTextColor="#FFFFFF"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default QueueEditModal;

// import { useState } from "react";
// import Button from "../Dealers/Button";

// const QueueEditModal = ({
//   item,
//   maxQueue,
//   onConfirm,
//   onClose,
//   mode,
//   activeType,
// }) => {
//   const [val, setVal] = useState(item?.queueNo ?? 1);

//   const primaryLabel = item?.voucherNo
//     ? "Voucher No"
//     : item?.machine && activeType === "Machine Wise"
//       ? "Machine"
//       : "Order Id";

//   const primaryValue = item?.voucherNo || item?.orderId || item?.machine || "-";

//   const handleConfirm = () => {
//     const newPosition = Math.max(1, Math.min(maxQueue, Number(val) || 1));
//     onConfirm(newPosition);
//     onClose();
//   };

//   const surface = mode ? "#1B1D21" : "#F4F6FA";
//   const border = mode ? "#2E3035" : "#E5E7EB";
//   const textMuted = mode ? "#9CA3AF" : "#6B7280";

//   return (
//     <div
//       onClick={onClose}
//       style={{
//         position: "fixed",
//         inset: 0,
//         backgroundColor: "rgba(0,0,0,0.5)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 10000,
//         padding: 20,
//       }}
//     >
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           width: "100%",
//           maxWidth: 440,
//           backgroundColor: mode ? "#232529" : "#FFFFFF",
//           color: mode ? "#FFFFFF" : "#111827",
//           borderRadius: 20,
//           border: `0.5px solid ${border}`,
//           padding: 28,
//         }}
//       >
//         {/* Header */}
//         <div style={{ textAlign: "center", marginBottom: 24 }}>
//           <p style={{ fontSize: 18, fontWeight: 500, margin: "0 0 4px" }}>
//             Update <span style={{ color: "#4164E3" }}>{activeType}</span> queue
//             position
//           </p>
//           <p style={{ fontSize: 13, color: textMuted, margin: 0 }}>
//             Change the queue position for this production
//           </p>
//         </div>

//         {/* Info Card */}
//         <div
//           style={{
//             background: surface,
//             borderRadius: 12,
//             padding: 16,
//             marginBottom: 20,
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//           }}
//         >
//           {[
//             { label: primaryLabel, value: primaryValue, bold: true },
//             item?.customer && { label: "Customer", value: item.customer },
//             item?.itemCode && {
//               label: "Item Code",
//               value: item.itemCode,
//               bold: true,
//             },
//             item?.collection &&
//               item.collection !== "—" && {
//                 label: "Collection",
//                 value: item.collection,
//               },
//             item?.machine &&
//               activeType !== "Machine Wise" && {
//                 label: "Machine",
//                 value: item.machine,
//               },
//           ]
//             .filter(Boolean)
//             .map((row, i, arr) => (
//               <div key={i}>
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <span style={{ fontSize: 12, color: mode ? "#ffffff" : "#000000" }}>
//                     {row.label}
//                   </span>
//                   <span
//                     style={{ fontSize: 13, fontWeight: row.bold ? 500 : 400 }}
//                   >
//                     {row.value}
//                   </span>
//                 </div>
//                 {i < arr.length - 1 && (
//                   <div
//                     style={{ height: 0.5, background: border, marginTop: 10 }}
//                   />
//                 )}
//               </div>
//             ))}
//         </div>
//         <p
//           style={{
//             textAlign: "left",
//             fontSize: 12,
//             color: textMuted,
//             margin: "10px 5px",
//             fontWeight: 500,
//           }}
//         >
//           Move queue position between 1 – {maxQueue}
//         </p>

//         {/* Queue Position */}
//         <div style={{ marginBottom: 22 }}>
//           <div
//             style={{
//               display: "flex",
//               gap: 14,
//               alignItems: "stretch",
//               marginBottom: 8,
//             }}
//           >
//             {/* Current */}
//             <div
//               style={{
//                 flex: 1,
//                 background: surface,
//                 borderRadius: 12,
//                 padding: "14px 16px",
//                 textAlign: "center",
//               }}
//             >
//               <p
//                 style={{
//                   fontSize: 13,
//                   color: textMuted,
//                   margin: "0 0 8px",
//                   letterSpacing: "0.04em",
//                   fontWeight:500
//                 }}
//               >
//                 Current
//               </p>
//               <p
//                 style={{
//                   fontSize: 32,
//                   fontWeight: 500,
//                   color: textMuted,
//                   margin: 0,
//                   lineHeight: 1,
//                 }}
//               >
//                 {item?.queueNo || 1}
//               </p>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 color: textMuted,
//               }}
//             >
//               →
//             </div>

//             {/* New */}
//             <div
//               style={{
//                 flex: 1,
//                 borderRadius: 12,
//                 border: "1.5px solid #4164E3",
//                 padding: "14px 16px",
//                 textAlign: "center",
//               }}
//             >
//               <p
//                 style={{
//                   fontSize: 13,
//                   color: "#4164E3",
//                   margin: "0 0 8px",
//                   letterSpacing: "0.04em",
//                   fontWeight:500
//                 }}
//               >
//                 New position
//               </p>
//               <input
//                 type="number"
//                 min={1}
//                 max={maxQueue}
//                 value={val}
//                 onChange={(e) => setVal(e.target.value)}
//                 style={{
//                   width: "100%",
//                   border: "none",
//                   background: "transparent",
//                   textAlign: "center",
//                   fontSize: 32,
//                   fontWeight: 500,
//                   color: "#4164E3",
//                   outline: "none",
//                   padding: 0,
//                   lineHeight: 1,
//                 }}
//               />
//             </div>
//           </div>
//         </div>

//         {/* Actions */}
//         <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
//           <Button
//             buttonClick={onClose}
//             buttonText="Cancel"
//             buttonBgColor="#000000"
//             buttonTextColor={"#ffffff"}
//           />
//           <Button
//             buttonClick={handleConfirm}
//             buttonText="Confirm"
//             buttonBgColor="#4164E3"
//             buttonTextColor="#FFFFFF"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default QueueEditModal;

import { useState, useRef, useEffect } from "react";
import Button from "../Dealers/Button";

const QueueEditModal = ({
  item,
  maxQueue,
  onConfirm,
  onClose,
  mode,
  activeType,
  queueloader,
}) => {
  const [val, setVal] = useState("");
  const inputRef = useRef(null);

  const primaryLabel = item?.voucherNo
    ? "Voucher No"
    : item?.machine && activeType === "Machine Wise"
      ? "Production Line"
      : "Voucher Id";

  const primaryValue = item?.voucherNo || item?.orderId || item?.machine || "-";

  // Auto focus input when modal opens
  useEffect(() => {
    const timer = setTimeout(() => {
      inputRef.current?.focus();
    }, 50);
    return () => clearTimeout(timer);
  }, []);

  const handleConfirm = () => {
    // const newPosition = Math.max(1, Math.min(maxQueue, Number(val) || 1));
    const newPosition = Math.max(1, Math.min(Number(val) || 1));
    onConfirm(newPosition);
    // onClose();
  };

  // Enter key triggers confirm
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleConfirm();
    }
  };

  const surface = mode ? "#1B1D21" : "#F4F6FA";
  const border = mode ? "#2E3035" : "#E5E7EB";
  const textMuted = mode ? "#9CA3AF" : "#6B7280";

  const hasValue = (value) =>
    value !== undefined && value !== null && value !== "";

  const isItemOrProductionLine =
    activeType === "Item Wise" || activeType === "Production Line Wise";

  const currentQueue = isItemOrProductionLine
    ? hasValue(item?.voucherQueue) && hasValue(item?.queueNo)
      ? `${item.voucherQueue}/${item.queueNo}`
      : hasValue(item?.voucherQueue)
        ? item.voucherQueue
        : hasValue(item?.queueNo)
          ? item.queueNo
          : ""
    : hasValue(item?.queueNo)
      ? item.queueNo
      : "";

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: 440,
          backgroundColor: mode ? "#232529" : "#FFFFFF",
          color: mode ? "#FFFFFF" : "#111827",
          borderRadius: 20,
          border: `0.5px solid ${border}`,
          padding: 28,
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <p style={{ fontSize: 18, fontWeight: 500, margin: "0 0 4px" }}>
            Update <span style={{ color: "#4164E3" }}>{activeType}</span> queue
          </p>
          <p style={{ fontSize: 13, color: textMuted, margin: 0 }}>
            Change the queue position for this production
          </p>
        </div>

        {/* Info Card */}
        <div
          style={{
            background: surface,
            borderRadius: 12,
            padding: 16,
            marginBottom: 20,
            display: "flex",
            flexDirection: "column",
            gap: 10,
          }}
        >
          {[
            { label: primaryLabel, value: primaryValue, bold: true },
            item?.customer && { label: "Customer", value: item.customer },
            item?.itemCode && {
              label: "Item Code",
              value: item.itemCode,
              bold: true,
            },
            item?.collection &&
              item.collection !== "—" && {
                label: "Collection",
                value: item.collection,
              },
            item?.machine &&
              activeType !== "Machine Wise" && {
                label: "Production Line",
                value: item.machine,
              },
          ]
            .filter(Boolean)
            .map((row, i, arr) => (
              <div key={i}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      fontSize: 12,
                      color: mode ? "#ffffff" : "#000000",
                    }}
                  >
                    {row.label}
                  </span>
                  <span
                    style={{ fontSize: 13, fontWeight: row.bold ? 500 : 400 }}
                  >
                    {row.value}
                  </span>
                </div>
                {i < arr.length - 1 && (
                  <div
                    style={{ height: 0.5, background: border, marginTop: 10 }}
                  />
                )}
              </div>
            ))}
        </div>

        <p
          style={{
            textAlign: "left",
            fontSize: 12,
            color: textMuted,
            margin: "10px 5px",
            fontWeight: 500,
          }}
        >
          {maxQueue}
        </p>

        {/* Queue Position */}
        <div style={{ marginBottom: 22 }}>
          <div
            style={{
              display: "flex",
              gap: 14,
              alignItems: "stretch",
              marginBottom: 8,
            }}
          >
            {/* Current */}
            <div
              style={{
                flex: 1,
                background: surface,
                borderRadius: 12,
                padding: "14px 16px",
                textAlign: "center",
              }}
            >
              <p
                style={{
                  fontSize: 13,
                  color: textMuted,
                  margin: "0 0 8px",
                  letterSpacing: "0.04em",
                  fontWeight: 500,
                }}
              >
                Current Queue
              </p>
              <p
                style={{
                  fontSize: 32,
                  fontWeight: 500,
                  color: textMuted,
                  marginTop: 20,
                  lineHeight: 1,
                }}
              >
                {/* {item?.queueNo || 1} */}
                {currentQueue}
              </p>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                color: textMuted,
              }}
            >
              →
            </div>

            {/* New */}
            <div
              style={{
                flex: 1,
                borderRadius: 12,
                border: "1.5px solid #4164E3",
                padding: "14px 16px",
                textAlign: "center",
              }}
            >
              <p
                style={{
                  fontSize: 13,
                  color: "#4164E3",
                  margin: "0 0 8px",
                  letterSpacing: "0.04em",
                  fontWeight: 500,
                }}
              >
                New Queue
              </p>
              <input
                ref={inputRef}
                type="number"
                min={1}
                max={maxQueue}
                value={val}
                // placeholder={item?.queueNo || 1}
                onChange={(e) => setVal(e.target.value)}
                onKeyDown={handleKeyDown}
                style={{
                  width: "100%",
                  border: "none",
                  background: "transparent",
                  textAlign: "center",
                  fontSize: 32,
                  fontWeight: 500,
                  color: "#4164E3",
                  outline: "none",
                  padding: 0,
                  lineHeight: 1,
                }}
              />
            </div>
          </div>
        </div>

        {/* Actions */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <Button
            buttonClick={onClose}
            buttonText="Cancel"
            buttonBgColor="#000000"
            buttonTextColor={"#ffffff"}
          />
          <Button
            loading={queueloader}
            buttonClick={handleConfirm}
            buttonText="Confirm"
            buttonBgColor="#4164E3"
            buttonTextColor="#FFFFFF"
          />
        </div>
      </div>
    </div>
  );
};

export default QueueEditModal;
